module.exports = __webpack_public_path__ + "static/profile-jim-8b7136e6ad7db4ddb0e20466c0d26f13.jpg";